module.exports = __webpack_public_path__ + "static/media/hablalo-icon.74c2c154.webp";